import { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux'
import { withStyles } from '@mui/styles';
import InterventionReportBloc from '../InterventionReportBloc'
import { blocsAreDifferents, setExpandedBloc } from '../../../redux/intervention/interventionActions';
import { getCurrentFunctionName } from '../../../performanceModeManager';
import { SIGNATURES_BLOC_TYPE_CODE } from '../../../redux/intervention/interventionConstants';

const styles = {
    root: {
        width: '100%',
        marginTop: "5px",
    },
};

class FixedTab extends Component {

    constructor(props) {
        super(props);
        let blocTypes = []
        if (props.category) {
            blocTypes = props.blocTypes.filter((bt) => bt.category_id.id === props.category.id)
        }
        else {
            blocTypes = props.blocTypes
        }

        this.state = {
            blocTypes,
            blocs: this.props.blocs.filter((b) => blocTypes.find((bt) => bt.id === b.type_id)),
        }
    }

    componentDidMount() {
        this.props.blocs.forEach((b) => {
            b.signed_by_customer = false;
        });
    }

    shouldComponentUpdate(nextProps, nextState){
        let expandedChange = this.props.expandedBloc !== nextProps.expandedBloc;
        let selectedTabChange = this.props.selectedTab !== nextProps.selectedTab;
        return selectedTabChange || expandedChange || blocsAreDifferents(nextState.blocs, this.state.blocs);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let blocs = nextProps.blocs.filter((b) => prevState.blocTypes.find((bt) => bt.id === b.type_id));
        return { blocs };
    }

    handleChange = blocId => {
        let collapsing = blocId === this.props.expandedBloc

        this.props.setExpandedBloc(collapsing ? null : blocId)
    };

    render() {
        console.perfLog(getCurrentFunctionName());
        const { classes } = this.props;

        if(!this.props.selectedTab && !this.props.preview && ! this.props.controlSignature)
            return null;

        if (this.state.blocs.length <= 0)
            return (<div></div>);

        let blocElements = [];

        this.state.blocTypes.sort((bt) => bt.category_id.id);

        this.state.blocTypes.forEach((bt,i) => {
            let matchingBloc = this.state.blocs.filter((mb) => mb.type_id === bt.id);
            matchingBloc.forEach((b,j) => {
                blocElements.push(
                    <InterventionReportBloc currentBlocId={b.mobile_id} key={i + j} blocValues={b}
                        id={"bloc-" + bt.id + "-" + i} blocType={bt}
                        onClick={this.handleChange.bind(this)} fieldValueChange={this.props.fieldValueChange.bind(this)}
                        addOrRemoveBloc={this.props.addOrRemoveBloc.bind(this)} validated={b.validated} signed_by_customer={b.signed_by_customer} />
                );
            });
        });

        return (
            <div className={classes.root}>
                {blocElements.map((be) => be)}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        preview: state.intervention.preview,
        controlSignature: state.intervention.controlSignature,
        blocTypes: state.interventions.blocTypes.filter((bt) => !bt.category_id.removable && bt.code !== SIGNATURES_BLOC_TYPE_CODE),
        blocs: state.intervention.blocs,
        expandedBloc: state.intervention.expandedBloc,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setExpandedBloc: (blocId) => dispatch(setExpandedBloc(blocId))
    };
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(FixedTab);
